<template src="./Task.html"></template>

<script>
import {createNamespacedHelpers} from 'vuex';
import BrandSelect from "@/components/components/BrandSelect"
import SearchQuery from "@/components/suppliers/components/SearchQuery"
import TopMenu from "@/components/suppliers/components/topMenu"
import CountrySelect from "@/components/components/countrySelect/CountrySelect"

const {mapGetters, mapActions} = createNamespacedHelpers('suppliers/task');

export default {
  name: "SuppliersTask",
  components: {
    BrandSelect,
    SearchQuery,
    TopMenu,
    CountrySelect,
  },
  data() {
    return {
      showOverlay: false,
      taskData: {
        brand: null,
        requests: [],
        searchDepth: 100,
        region: 'all'
      },
      fieldReset: true,
      depthOptions: [
        {value: 10, text: "10"},
        {value: 20, text: "20"},
        {value: 30, text: "30"},
        {value: 50, text: "50"},
        {value: 100, text: "100"},
      ],
    }
  },
  methods: {
    ...mapActions(['SAVE']),
    addTask() {
      // check is fill require fields
      if (this.taskData.brand == null || Object.keys(this.taskData.requests).length === 0) {
        this.$bvModal.show('emptyRequireData');
        return;
      }
      // prepare requests
      let requests = []
      for (let key in this.taskData.requests) {
        requests.push(this.taskData.requests[key].query)
      }
      let taskData = Object.assign({}, this.taskData)
      taskData.requests = requests

      this.SAVE({th: this, task: taskData})
    },
    brandsChange(brand) {
      this.taskData['brand'] = brand.id
      if (this.taskData.requests.length === 0) {
        this.taskData.requests.push({id: 0, query: brand.name})
      }
      this.$forceUpdate()
    },
    requestsChange() {
    },
    regionChange(region) {
      this.taskData['region'] = region
    }
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {
  },
  created() {
    if (this.$store.getters.getAllowSection.indexOf('suppliers') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }
  },
}
</script>

<style scoped>

.input-add-use {
  text-align: left;
}

.submit-button {
  text-align: right;
}
.toggle-button {
  float: right;
}

</style>